export const debounceTimeout = 250;

// Memoization purposes where we have to pass an array (e.g., data?.data ?? [])
export const emptyArray: any[] = [];

export const isStreetFreeInputAllowed =
  typeof process.env.REACT_APP_STREET_FREE_INPUT === 'string' &&
  !!parseInt(process.env.REACT_APP_STREET_FREE_INPUT);
